'use strict';
import _each from 'lodash/each';
import _reduce from 'lodash/reduce';
import _isPlainObject from 'lodash/isPlainObject';
import Utils from './Utils';

class XMLParser {
    constructor () { }

    flatten (object) {
        let check = _isPlainObject(object) && Object.keys(object).length === 1;
        return check ? this.flatten(Object.values(object)[0]) : object;
    }

    parse (xml) {
        let self = this; // cache this here
        let data = {};

        let isText = xml.nodeType === 3;
        let isElement = xml.nodeType === 1;
        let body = xml.textContent && xml.textContent.trim();
        let hasChildren = xml.children && xml.children.length;
        let hasAttributes = xml.attributes && xml.attributes.length;

        // if it's text just return it
        if (isText) {
            return xml.nodeValue.trim();
        }

        // if it doesn't have any children or attributes, just return the contents
        if (!hasChildren && !hasAttributes) {
            return body;
        }

        // if it doesn't have children but _does_ have body content, we'll use that
        if (!hasChildren && body.length) {
            data.text = body;
        }

        // if it's an element with attributes, add them to data.attributes
        if (isElement && hasAttributes) {
            // console.error(xml.attributes);

            data.attributes = _reduce(xml.attributes, function (obj, name, id) {
                let attr = xml.attributes.item(id);
                obj[attr.name] = attr.value;
                return obj;
            }, {});
        }

        // recursively call #parse over children, adding results to data
        // _each(xml.children, function (child) {
        //     console.log(child);
        //     var name = child.nodeName;
        //     console.log(name);
        // });
        // for(let i=0; i<xml.children.length; i++) {

        // sconsole.log(xml.children);
        // for (let child of xml.children) {
        _each(xml.children, function (child) {
        // xml.children.forEach(child => {
            // console.log(child);
            const name = child.nodeName;
            // console.log(name);

            // if we've not come across a child with this nodeType, add it as an object
            // and return here

            if (typeof data === 'object' && !Object.prototype.hasOwnProperty.call(data, name)) {
            // if (!_has(data, name)) {
                // console.log(self.parse(child));
                data[name] = self.parse(child);
                return;
            }

            // if we've encountered a second instance of the same nodeType, make our
            // representation of it an array
            // if (!Array.isArray(data[name])) {
            if (!Array.isArray(data[name])) {
                data[name] = [data[name]];
            }

            // and finally, append the new child
            data[name].push(self.parse(child));
        });

        // if we can, let's fold some attributes into the body
        // for (const [key, value] of Object.entries(data.attributes)) {
        _each(data.attributes, function (value, key) {
            if (data[key] !== null) {
                return;
            }
            data[key] = value;
            delete data.attributes[key];
        });

        // if data.attributes is now empty, get rid of it
        if (Utils.isEmpty(data.attributes)) {
            delete data.attributes;
        }

        // simplify to reduce number of final leaf nodes and return
        return self.flatten(data);
    }
}

export default XMLParser;
